import Radio from 'backbone.radio'

export default class QuizPlayerApi {
  constructor(target, options = {}) {
    this.target = target
    this.noScore = !!options.noScore
  }

  submitAnswer(questionId, answerId, tryNumber, cbSuccess) {
    const data = {
      target_type: this.target.type,
      target_id: this.target.id,
      question_id: questionId,
      answer_id: answerId,
      try_number: tryNumber,
    }

    if (this.noScore) data.no_score = '1'

    const xhr = {
      data: data,
      dataType: 'json',
      method: 'POST',
      url: SOPHIA.Routes.quiz_player_path()
    }

    const callbacks = {
      afterSuccess(response) {
        cbSuccess(response.result, response.quiz_take)
        if (response.result && response.result.correct)
          Radio.channel('global').trigger('quiz:score:update')
      }
    }

    SOPHIA.sendXHR(xhr, callbacks)
  }

}
